import { getFixedLength } from '@shared/utils';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFixedLength',
})
export class NumberFixedLengthPipe implements PipeTransform {
  transform(value: number, index: number): string {
    return getFixedLength(value, index);
  }
}
